import { c as create_ssr_component, b as add_attribute, v as validate_component } from "../../../chunks/ssr.js";
import { L as Limiter } from "../../../chunks/Limiter.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let bio;
  let { form } = $$props;
  let { data } = $$props;
  if ($$props.form === void 0 && $$bindings.form && form !== void 0)
    $$bindings.form(form);
  if ($$props.data === void 0 && $$bindings.data && data !== void 0)
    $$bindings.data(data);
  bio = data.bio;
  return `${$$result.head += `<!-- HEAD_svelte-1sdolww_START -->${$$result.title = `<title>Logged out</title>`, ""}<link rel="icon" type="image/png" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><link rel="apple-touch-icon" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><!-- HEAD_svelte-1sdolww_END -->`, ""} ${validate_component(Limiter, "Limiter").$$render($$result, {}, {}, {
    default: () => {
      return `<div class="pt-20">${form?.incorrect ? `<p class="p-4 bg-red-100 text-red-600 my-4 rounded-md" data-svelte-h="svelte-148gyu5">Error while signing out.</p>` : `Successfully logged out. <a class="underline" href="/" data-svelte-h="svelte-1dxmyjr">Continue</a>.`}</div>`;
    }
  })}`;
});
export {
  Page as default
};
